import { forwardRef, type Ref, type SVGProps } from "react";
const IconNotePlusFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M8 25a3 3 0 0 1-1.11-.21A11 11 0 0 1 5 23.72c-.32-.22-.65-.48-1-.77a12.4 12.4 0 0 1-2-2.237V26a2.006 2.006 0 0 0 2 2h20a2.006 2.006 0 0 0 2-2v-1Z"
    />
    <path
      fill="currentColor"
      d="M29.609 21.2A10.5 10.5 0 0 1 26 13V6a2.006 2.006 0 0 0-2-2H4a2.006 2.006 0 0 0-2 2v8a9.54 9.54 0 0 0 2 6.06 9.6 9.6 0 0 0 1 1.09 9.4 9.4 0 0 0 2.63 1.78A1 1 0 0 0 8 23h21a1 1 0 0 0 .61-1.8ZM18 15h-3v3a1 1 0 0 1-2 0v-3h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2M4 22.95c.35.29.68.55 1 .77a11 11 0 0 0 1.89 1.07A3 3 0 0 0 8 25a3 3 0 0 1-1.11-.21A11 11 0 0 1 5 23.72c-.32-.22-.65-.48-1-.77a12.4 12.4 0 0 1-2-2.24 12.4 12.4 0 0 0 2 2.24"
    />
  </svg>
);
const ForwardRef = forwardRef(IconNotePlusFilledSVG);
ForwardRef.displayName = "IconNotePlusFilled";
export { ForwardRef as IconNotePlusFilled };
